import { Setting } from 'api/settings/settings.api'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import StatusIcon from 'ui/atoms/StatusIcon/StatusIcon'
import ActiveSettingText from 'ui/components/ActiveSettingText/ActiveSettingText'

type SettingsStatusFieldProps = {
  value: Setting | null
}

export default function SettingsStatusField({ value }: SettingsStatusFieldProps): ReactElement {
  const { t } = useTranslation()

  return value ? (
    <StatusIcon
      variant="settings_deviation"
      tooltip={{
        title: <ActiveSettingText startTime={value.start_time} endTime={value.end_time} />,
        arrow: true,
        placement: `top`,
      }}
    />
  ) : (
    <StatusIcon variant="settings_no_deviation" tooltip={{ title: t(`No deviation`), arrow: true, placement: `top` }} />
  )
}
